import React, { Component } from 'react';
import { isEmpty } from 'lodash'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import AddCircle from '@mui/icons-material/AddCircle';
import SwapHorizontalCircle from '@mui/icons-material/SwapHorizontalCircle';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, FormHelperText, FormControl } from '@mui/material';

class PhotoUpload extends Component {
  state = {
    photo:this.props.photo,
  }

  onRemoveImage= async (e, index) => {
    e.preventDefault();
    
    this.setState({
      ...this.state,
      photo:{}
    });
    this.props.setPhoto(this.state.photo)// send photo to main component
  }

  handleAddImage= async (e) =>{
    e.preventDefault();
    let list = e.target.files;
    console.log("[INFO], Upload Image list", list);

    let photo = list[0];
    if(!photo){
      return
    }
    
    if(!photo.type.startsWith("image")){
      this.props.setPhoto(null, "Le format n'est pas valide")
      this.setState({
        photo: {}
      })
      return
    }

    let reader = new FileReader();

    reader.onloadend = async (upload) => {
      console.log("[INFO]onloadend upload reader ", reader);

      this.setState({ 
        ...this.state,  
        photo:{ 
            "data_uri": upload.target.result, 
            "filename": photo.name,
            "filetype": photo.type,
          }
      })
      this.props.setPhoto(this.state.photo) // send photo to main component
    }
    await reader.readAsDataURL(photo)// ??
  }
  
  render() {
    // console.log("[STATE] FILES", this.state.photo);
    const { photo } = this.state;
    const { saved, id, error, helperText } = this.props;
    return (
      <Box>
            <input 
              id={id || "photo-input"}
              type="file" 
              hidden
              onChange={this.handleAddImage }
            />
            {isEmpty(photo) && isEmpty(saved) &&
              <Button 
                startIcon={<AddCircle />}
                style={{ width: "100%"}} variant="contained" color="secondary" component="label" htmlFor={id || "photo-input"} className="photoinput-new"
              >
                {this.props.label || "Ajouter une photo"}
              </Button>
            }
            {!isEmpty(saved) && isEmpty(photo) &&
              <div className={"photoinput photoinput-exists"} data-provides="photoinput">
                <div 
                  className="photoinput-preview thumbnail" 
                  data-trigger="photoinput" 
                  style={{maxWidth: "250px", margin: "auto"}}
                >
                  <img src={saved} className="image"/>
                </div>

                <div>
                  <IconButton color="secondary" component="label" htmlFor={id || "photo-input"} size="large">
                    <SwapHorizontalCircle /> 
                  </IconButton>
                    Modifier
                </div>
              </div>
            }
            {!isEmpty(photo) &&
              <div className={"photoinput photoinput-exists"} data-provides="photoinput">
                <div 
                  className="photoinput-preview thumbnail" 
                  data-trigger="photoinput" 
                  style={{maxWidth: "250px", margin: "auto"}}
                >
                  <img src={photo.data_uri} className="image"/>
                </div>

                <div>
                  <IconButton color="secondary" component="label" htmlFor={id || "photo-input"} size="large">
                    <SwapHorizontalCircle /> 
                  </IconButton>
                </div>
              </div>
            }
            {(error || helperText) &&
              <FormControl error={!!error} >

                  <FormHelperText>{error || helperText}</FormHelperText>
              </FormControl>
            }
        </Box>
    );
  }
}

export default PhotoUpload
